export default __webpack_public_path__ + "static/media/025-delivery truck.e944bbb6.svg";